export default "__VITE_ASSET__t5n01mKA__"